import React, { useContext, useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import StateContext from "../StateContext";

import {
  BrowserRouter,
  Switch,
  Redirect,
  Route,
  Link,
  useHistory,
  useParams,
} from "react-router-dom";

const SimpleTabs = ({ count }) => {
  let { a, tap } = useParams();
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);
  const appState = useContext(StateContext);
  const [title, setTitle] = useState(t("dashboard.transactions"));
  // console.log(count)

  const handleChange = (event, newValue) => {
    if (newValue == 0) {
      setTitle(t("dashboard.transactions"));
    } else if (newValue == 1) {
      setTitle(t("dashboard.promocodes"));
    } else if (newValue == 2) {
      setTitle(t("dashboard.orders"));
    }  else if (newValue == 3) {
      setTitle(t("dashboard.rewards"));
    }else if (newValue == 4) {
      setTitle(t("dashboard.my-profile"));
    }

    setValue(newValue);
  };

  useEffect(() => {
    let path = window.location.pathname;
    // console.log(path)
    if (path === "/dashboard") {
       setValue(2);
      setTitle(t("dashboard.orders"));
    }  else if (path === "/dashboard/transactions" && value !== 0) {
      setValue(0);
      setTitle(t("dashboard.transactions"));
    } else if (path === "/dashboard/promo" && value !== 1) {
      setValue(1);
      setTitle(t("dashboard.promocodes"));
    }  else if (path === "/dashboard/orders" && value !== 2) {
      setValue(2);
      setTitle(t("dashboard.orders"));
    } else if (path === "/dashboard/rewards" && value !== 3) {
      setValue(3);
      setTitle(t("dashboard.rewards"));
    }else if (path === "/dashboard/profile" && value !== 4) {
      setValue(4);
      setTitle(t("dashboard.my-profile"));
    }
  }, [value]);
useEffect(() => {
  setValue(2);
  setTitle(t("dashboard.orders"));
  
}, [])


  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-3 d-flex flex-column">
            <div className="row main_area_heading mr-auto mx-5">
              
                <h4 className="text-uppercase d-flex text-center"> <strong>{title}</strong></h4>
              
            </div>
            {title == t("dashboard.my-profile") || title == "Wallet" ? (
              ""
            ) : (
              <div className="row mr-auto mx-5">
                
                  <p className="small text-uppercase d-flex  ">
                    <strong className="px-1">{count}</strong>{" "}
                    <span className="text-muted text-left"> {title}</span>
                  </p>
                
              </div>
            )}
          </div>
          <div className="col-sm-9 d-lg-block d-none tabNavigationParent">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
            >
              {/* <Tab
                label={"wallet"}
                component={Link}
                to={`/dashboard/wallet`}
              /> */}
              <Tab
                label={t("dashboard.transactions")}
                component={Link}
                to={`/dashboard/transactions`}
              />
              <Tab
                label={t("dashboard.promocodes")}
                component={Link}
                to={`/dashboard/promo`}
              />
            
              <Tab
                label={t("dashboard.orders")}
                component={Link}
                to={`/dashboard/orders`}
              />
              <Tab
                label={t("dashboard.rewards")}
                component={Link}
                to={`/dashboard/rewards`}
              />
                <Tab
                label={t("dashboard.my-profile")}
                component={Link}
                to={`/dashboard/profile`}
              />
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(SimpleTabs);
